import { NavLink } from 'react-router'
import { PhoneScreenshotFrame } from './LandingScreenshotFrames'
import { useMyClub } from '../../app/hooks/UseMyClub.ts'
import heroScreenshot from '../../assets/hero/hero-screenshot.webp'

export default function LandingHero() {
  const { userLoaded, myClubPath } = useMyClub()
  const myClubHref = userLoaded ? myClubPath : undefined

  return (
    <div className="relative isolate overflow-hidden bg-gray-900 pt-14">
      <div
        className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
        aria-hidden="true">
        <div
          className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-20 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
          style={{
            clipPath:
              'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
          }}
        />
      </div>
      <div className="mx-auto max-w-7xl px-6 py-12 sm:py-16 lg:px-8">
        <div className="grid grid-cols-1 items-center gap-x-16 gap-y-14 lg:grid-cols-2">
          <div className="text-center lg:text-left">
            <h1 className="text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl">
              The club schedule that fills itself
            </h1>
            <p className="mt-6 text-lg leading-8 text-gray-300">
              Members claim speeches and roles themselves, auto-assign fills
              whatever&apos;s left - and Club Officers get their evenings
              back
            </p>
            <div className="mt-10 flex flex-col items-center gap-y-4 sm:flex-row sm:justify-center sm:gap-x-8 lg:justify-start">
              {myClubHref ? (
                <NavLink
                  data-testid="go-to-my-club-link"
                  to={myClubHref}
                  className="rounded-md bg-indigo-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-400">
                  Go to my club
                </NavLink>
              ) : (
                <NavLink
                  to="/register-club"
                  className="rounded-md bg-indigo-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-400">
                  Start your club free
                </NavLink>
              )}
              <div className="text-center sm:text-left">
                <NavLink
                  to="/clubs"
                  className="text-sm font-semibold leading-6 text-white">
                  See a real club&apos;s live schedule{' '}
                  <span aria-hidden="true">→</span>
                </NavLink>
                <p className="text-xs leading-5 text-gray-400">
                  live right now · no account needed
                </p>
              </div>
            </div>
            <p className="mt-8 text-sm leading-6 text-gray-400">
              Free to start · Nothing to install - works in any browser · No
              account needed to view a schedule
            </p>
          </div>
          <div className="relative mx-auto w-full max-w-sm lg:max-w-md">
            <div
              className="absolute -inset-8 -z-10 rounded-full bg-indigo-500/20 blur-3xl"
              aria-hidden="true"
            />
            <PhoneScreenshotFrame
              src={heroScreenshot}
              alt="Live agenda showing club meeting participants and roles, with one role already claimed"
              imageClassName="ml-2 object-cover object-top"
              className="max-w-[18rem] rotate-2 lg:max-w-[19rem]">
              <div className="absolute -left-6 top-16 z-10 max-w-36 rounded-lg bg-white/95 p-3 text-left shadow-xl shadow-indigo-950/30 ring-1 ring-gray-200 block">
                <p className="text-xs font-semibold text-indigo-600">
                  Live agenda
                </p>
                <p className="mt-1 text-sm font-semibold leading-5 text-gray-900">
                  Members see what is open before they volunteer
                </p>
              </div>
              <div className="absolute -right-7 bottom-20 z-10 max-w-36 rounded-lg bg-indigo-500 p-3 text-left shadow-xl shadow-indigo-950/40 block">
                <p className="text-xs font-semibold text-indigo-100">
                  No login to view
                </p>
                <p className="mt-1 text-sm font-semibold leading-5 text-white">
                  Guests can check the schedule from any phone
                </p>
              </div>
            </PhoneScreenshotFrame>
          </div>
        </div>
      </div>
    </div>
  )
}
